import { baseUrl as rootBaseURL } from '../../baseUrl'

export const baseURL = `${rootBaseURL}/additional`
